import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs';

@Component({
  selector: 'gen-curation-editor-action-message',
  templateUrl: './curation-editor-action-message.component.html',
  styleUrls: ['./curation-editor-action-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurationEditorActionMessageComponent implements OnInit {

  public tunnel$: Subject<any>;
  public callback: (model) => Observable<Response>;
  public payload: any;
  public message: string;

  constructor() {
  }

  ngOnInit() {
    this.tunnel$.asObservable().filter(value => value.emitter !== 'child').subscribe(next => {
      next.value && this.submit(this.payload);
    });
  }

  submit(model) {
    model['message'] = this.message;
    this.callback(model)
      .subscribe((model) => {
        this.tunnel$.next({ emitter: 'child', value: model});
      });
  }

}
